<template>
  <ContextColorProvider context="brand">
    <NavBar
      v-if="customer"
      class="header-impersonate"
      data-testid="header-impersonate"
    >
      <template #center>
        <span>Você está logado na conta de {{ customer.name }}</span>
      </template>
      <template #right>
        <Button
          class="impersonate__button"
          size="sm"
          :on-click="leaveImpersonate"
        >
          <span class="text-p6-semibold">sair</span>
        </Button>
      </template>
    </NavBar>
  </ContextColorProvider>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import {
  ContextColorProvider,
  NavBar,
  Button
} from '@warrenbrasil/nebraska-web';
import { logoutImpersonate } from '@/modules/common/services/partner';
import { Categories } from '@/types/models/Analytics';
import { ICustomer } from '@/types/models';
import { GtmTracker } from '@/modules/common/services/analytics';
import { getURLParams } from '@/modules/wallet-builder/src/helpers';

const customerModule = namespace('CustomerModule');

@Component({
  components: {
    ContextColorProvider,
    NavBar,
    Button
  }
})
export default class ImpersonateHeader extends Vue {
  @customerModule.Getter('getCustomer')
  private customer?: ICustomer;

  private leaveImpersonate() {
    this.trackLeaveClick();
    const urlParams = getURLParams(true);

    if (urlParams?.backTo) {
      window.location.replace(urlParams.backTo);
      return;
    }

    logoutImpersonate();
  }

  private trackLeaveClick() {
    GtmTracker.trackEvent({
      action: 'click_cancelar',
      category: Categories.ClientDetails,
      label: ''
    });
  }
}
</script>

<style lang="less" scoped>
@navbar-impersonate: 48px;

.header-impersonate {
  width: 100%;
  height: @navbar-impersonate !important;
  background: @theme-primary !important;
  position: fixed;
  top: 0;
  z-index: 15;
  color: @theme-over-primary !important;
}

.impersonate__button {
  outline: none;
}
</style>
